module.exports = __webpack_public_path__ + "static/og-c086a215e4b6aff9fb7863fd06320101.png";